import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  Divider,
  useMediaQuery,
  useTheme,
  Stack,
} from '@mui/material';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

const AboutReviewPlatform = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
const primaryColor = '	#C2185B';

  const sections = [
    {
      icon: <ShoppingBagIcon sx={{ fontSize: 32, color: primaryColor }} />,
      title: 'For Users',
      description:
        'Tired of fake reviews? Our community of real users share their original product experiences — including photos and videos — so you can buy with trust and transparency. Search any product, read honest feedback, and purchase directly from the provided links.',
      image: '/assets/Users.png',
      imagePosition: 'left',
    },
    {
      icon: <BusinessCenterIcon sx={{ fontSize: 32, color: primaryColor }} />,
      title: 'For Resellers',
      description:
        "If you're a Meesho or Flipkart/Amazon reseller, finding good-quality products is now easier than ever. Browse through user-verified reviews with original images and trusted product links. Choose the best-selling items backed by real feedback and increase your customer satisfaction.",
      image: '/assets/reseller.png',
      imagePosition: 'right',
    },
    {
      icon: <RocketLaunchIcon sx={{ fontSize: 32, color: primaryColor }} />,
      title: 'Start Your Journey Today',
      description:
        "Simply create an account and start reviewing or browsing. The more you share, the more visibility and badges you earn. Whether you're shopping or reselling — we've got the tools you need to succeed!",
      image: '/assets/start.png',
      imagePosition: 'left',
    },
  ];

  return (
    <Box sx={{ px: { xs: 2, sm: 4 }, py: 8, backgroundColor: '#fff' }}>
      {/* Heading */}
      <Typography
        variant="h4"
        fontWeight="bold"
        textAlign="center"
        sx={{ color: primaryColor, mb: 2 }}
      >
        Welcome to India&apos;s Trusted Product Review Platform
      </Typography>

      {/* Subtitle */}
      <Typography
        variant="subtitle1"
        color="text.secondary"
        textAlign="center"
        maxWidth={800}
        mx="auto"
        mb={8}
        sx={{ lineHeight: 1.8 }}
      >
        Our platform helps <strong>shoppers</strong> and <strong>resellers</strong> make confident
        decisions by offering genuine product reviews with real photos, videos, and trusted buy
        links from platforms like <strong>Meesho</strong>, <strong>Flipkart</strong>, and{' '}
        <strong>Amazon</strong>.
      </Typography>

      {/* Sections */}
      <Stack spacing={6}>
        {sections.map((section, index) => {
          const isImageLeft = section.imagePosition === 'left';

          return (
            <Card
              key={index}
              elevation={0}
              sx={{
                p: { xs: 2, sm: 4 },
                borderRadius: 4,
                display: 'flex',
                flexDirection: isSmallScreen
                  ? 'column'
                  : isImageLeft
                  ? 'row'
                  : 'row-reverse',
                alignItems: 'center',
                gap: 4,
                backgroundColor: '#f9f9f9',
              }}
            >
              {/* Image */}
              <Box
                component="img"
                src={section.image}
                alt={section.title}
                sx={{
                  width: { xs: '100%', sm: 320 },
                  height: 'auto',
                  borderRadius: 2,
                  flexShrink: 0,
                }}
              />

              {/* Text */}
              <Box flex={1}>
                <Box display="flex" alignItems="center" mb={2}>
                  {section.icon}
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    sx={{ color: primaryColor, ml: 1 }}
                  >
                    {section.title}
                  </Typography>
                </Box>
                <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                  {section.description}
                </Typography>
              </Box>
            </Card>
          );
        })}
      </Stack>
    </Box>
  );
};

export default AboutReviewPlatform;
